//import { mapState } from "vuex";

import FieldForm from '@/components/FieldForm'
import FormSection from '@/components/FormSection'

export default {
    components: {
        FieldForm,
        FormSection
    },
    data() {
        return {
            saving: false,
            rules: {
                required: v=> !!v || this.$t('form.rules.required'),
                email: (v) => !v || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) || this.$t('form.rules.email'),
                phone: (v) => !v || /^\+\d{10,12}$/.test(v) || this.$t('form.rules.phone'),
                inbox: (v) => !v || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/.test(v) || this.$t('form.rules.inbox'),
                dnsName: (v) => !v || /^[a-z0-9][a-z0-9-]{1,61}[a-z0-9]\.[a-z]{2,}$/.test(v) || this.$t('form.rules.dnsName'),
                bounce: (v) => !v || /^[a-z]+[a-z-]*[a-z]+$/.test(v) || this.$t('form.rules.bounce'),
                url: (v) => !v || this.isValidUrl(v) || this.$t('form.rules.url'),
                condRequired: (f) => (v) => !!f || !!v || this.$t('form.rules.required')
            },
        };
    },
    watch: {
        item() {
            this.loadAttrs();
        }
    },
    computed: {
        // cant use mapState, this is not defined at the moment of the call
        item() {
            if (!this.endpoint) {
                console.error('Entity form mixin: No entity endpoint defined in referencing component');
                return null;
            }
            return this.$store.state[this.endpoint].item;
        }
    },
    methods: {
        loadAttrs() {
            if (!this.fields || !this.item) {
                return;
            }
            Object.keys(this.fields).forEach(a => {
                // there might be a problem with dates
                // https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
                // https://dassur.ma/things/deep-copy/
                this.fields[a] = (this.item[a] !== null && this.item[a] !== undefined) ? JSON.parse(JSON.stringify(this.item[a])) : null;
            });
            if (this.afterFieldsLoad && typeof (this.afterFieldsLoad) === 'function') {
                //console.debug('Calling afterFieldsLoad');
                this.afterFieldsLoad();
            }
        },
        detectChange(o1, o2) {
            /* not working as o2 contains id when called from detectChange
            let res = JSON.stringify(o1) !== JSON.stringify(o2);
            console.debug(`Entity Form: comparing fields, results ${res}`);
            if(res) {
                //console.dir(o1);
                console.debug(JSON.stringify(o1));
                //console.dir(o2);
                console.debug(JSON.stringify(o2));
            }*/
            
            //return res;
            
            if(o1 != null && typeof(o1) === 'object') {
                if(Array.isArray(o1)) {
                    //console.debug('Array');
                    //console.dir(o1);
                    //console.dir(o2);
                    let res = o1.length != o2?.length || o1.some((e, i) => this.detectChange(e, o2[i]) /*o2[i] != e*/ );
                    //console.debug(res);
                    if(res) {
                        //console.debug('detect change o1',o1);
                        //console.debug('detect change o2',o2);
                    }
                    return res;
                } else {
                    // if o2 doesnt exist, there is a change
                    return Object.keys(o1).some(key => o2 ? this.detectChange(o1[key], o2[key]) : true);
                }
            } else {
                //console.debug(`o1 != o2`);
                let res = o1 != o2;
                if(res) {
                    //console.debug('detect change o1', o1);
                    //console.debug('detect change o2', o2);
                }
                return res;
            }
        },
        isDirty() {
            /* not a good solution - causes a problem when exiting the wizard
            isDirty must be used for such cases
            if (this.prepareFields && typeof (this.prepareFields) === 'function') {
                await this.prepareFields();
            }
            */
            return this.detectChange(this.fields, this.item);
        },
        async save(nowizard) {
            if (!this.fields) {
                console.error('Fields object not present');
                return;
            }
            if (!this.endpoint) {
                console.error('Endpoint not present');
                return;
            }
            //console.debug('saving form');
            //console.dir(this.fields);
            //console.dir(this.item);
            // identify new
            var fields = {};
            if (this.prepareFields && typeof (this.prepareFields) === 'function') {
                let canSave = await this.prepareFields(nowizard);
                if(canSave === false) {
                    console.debug('prepareFields stopped the save');
                    return;
                }
            }
            Object.keys(this.fields).forEach(a => {
                if (this.detectChange(this.fields[a], this.item[a])) {
                    // copy the value for the saving (so we can store e.g. AWS JSON)
                    fields[a] = JSON.parse(JSON.stringify(this.fields[a]));
                }
            });
            //console.dir(fields);
            if (this.beforeSave && typeof (this.beforeSave) === 'function') {
                await this.beforeSave(fields);
            }
            //console.dir(fields);
            if(Object.keys(fields).length == 0) {
                console.debug('Nothing to save');
                if (this.afterSave && typeof (this.afterSave) === 'function') {
                    await this.afterSave(results);
                }
                if(this.wizard && !nowizard) {
                    this.nextStep(this.wizardParams || {});
                }
                return;
            } 
            this.saving = true;
            var results = await this.$store.dispatch(`${this.endpoint}/updateFields`, {
                fields
            }); 
            this.saving = false; 
            this.$store.dispatch('ui/notify', { text: this.$t('form.saved')});
            if (this.afterSave && typeof (this.afterSave) === 'function') {
                await this.afterSave(results);
            }
            if(this.wizard && !nowizard) {
                this.nextStep(this.wizardParams || {});
            }
        },
        // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
        isValidUrl(string) {
            let url;
            try {
                url = new URL(string);
            } catch (_) {
                return false;  
            }
            return url.protocol === "http:" || url.protocol === "https:";
        },
    },
    created() {
        this.loadAttrs();
    }
}